export type PaymentsEnv = "sandbox" | "live";

const clientToken = import.meta.env["VITE_PAYMENTS_CLIENT_TOKEN"] as string | undefined;

/** Derived from the token prefix so a test-mode build never touches live data. */
export function paymentsEnvironment(): PaymentsEnv {
  if (clientToken?.startsWith("pk_test_")) return "sandbox";
  if (clientToken?.startsWith("pk_live_")) return "live";
  throw new Error(
    "Payments are not configured for this build. Finish the payments go-live steps to enable checkout.",
  );
}

/** Same rule, but safe to call before payments are configured. */
export function paymentsEnvironmentOrDefault(): PaymentsEnv {
  if (clientToken?.startsWith("pk_live_")) return "live";
  return "sandbox";
}

export function paymentsConfigured(): boolean {
  return Boolean(
    clientToken && (clientToken.startsWith("pk_test_") || clientToken.startsWith("pk_live_")),
  );
}

export function paymentsClientToken(): string | undefined {
  return clientToken;
}
